import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBatteryStatusIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M40.4559 17.9597H21.544C20.5023 17.9597 19.6504 18.8158 19.6504 19.8626V31.7962C19.6504 32.843 20.5023 33.6991 21.544 33.6991H40.4559C41.4976 33.6991 42.3495 32.843 42.3495 31.7962V19.8626C42.3495 18.8158 41.4976 17.9597 40.4559 17.9597ZM40.5839 31.7917C40.5839 31.8583 40.5221 31.9204 40.4559 31.9204H21.544C21.4778 31.9204 21.416 31.8583 21.416 31.7917V19.8626C21.416 19.7961 21.4778 19.734 21.544 19.734H40.4559C40.5221 19.734 40.5839 19.7961 40.5839 19.8626V31.7962V31.7917Z",
			fill: "#1F3171"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.8701 25.319H30.151L32.138 23.1203C32.3237 22.9153 32.3536 22.5409 32.2063 22.2854C32.0591 22.0269 31.7902 21.9853 31.6066 22.1903L29.1095 24.9535L29.0732 25.0248C28.9068 25.3576 28.879 25.7231 28.9921 26.0291C29.1074 26.3351 29.34 26.5104 29.6303 26.5104H32.2917L30.3026 28.7477C30.119 28.9527 30.0913 29.3271 30.2385 29.5826C30.3218 29.7282 30.4456 29.8025 30.5715 29.8025C30.6654 29.8025 30.7614 29.7579 30.8404 29.6718L33.3119 26.8937L33.3717 26.8135C33.6427 26.3589 33.5573 25.9667 33.5061 25.8182C33.457 25.6696 33.2948 25.3249 32.8701 25.3249V25.319Z",
			fill: "#1F3171"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.8701 25.319H30.151L32.138 23.1203C32.3237 22.9153 32.3536 22.5409 32.2063 22.2854C32.0591 22.0269 31.7902 21.9853 31.6066 22.1903L29.1095 24.9535L29.0732 25.0248C28.9068 25.3576 28.879 25.7231 28.9921 26.0291C29.1074 26.3351 29.34 26.5104 29.6303 26.5104H32.2917L30.3026 28.7477C30.119 28.9527 30.0913 29.3271 30.2385 29.5826C30.3218 29.7282 30.4456 29.8025 30.5715 29.8025C30.6654 29.8025 30.7614 29.7579 30.8404 29.6718L33.3119 26.8937L33.3717 26.8135C33.6427 26.3589 33.5573 25.9667 33.5061 25.8182C33.457 25.6696 33.2948 25.3249 32.8701 25.3249V25.319Z",
			stroke: "#1F3171"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.5757 16.4278C36.5757 16.6785 36.779 16.8818 37.0297 16.8818H37.9933C38.244 16.8818 38.4473 16.6785 38.4473 16.4278V15.3353C38.4473 15.0845 38.6505 14.8813 38.9013 14.8813H39.9841C40.2348 14.8813 40.438 14.678 40.438 14.4273V13.4545C40.438 13.2038 40.2348 13.0005 39.9841 13.0005H38.9013C38.6505 13.0005 38.4473 12.7973 38.4473 12.5465V11.454C38.4473 11.2033 38.244 11 37.9933 11H37.0297C36.779 11 36.5757 11.2033 36.5757 11.454V12.5465C36.5757 12.7973 36.3725 13.0005 36.1217 13.0005H35.0389C34.7882 13.0005 34.585 13.2038 34.585 13.4545V14.4273C34.585 14.678 34.7882 14.8813 35.0389 14.8813H36.1217C36.3725 14.8813 36.5757 15.0845 36.5757 15.3353V16.4278Z",
			fill: "#1F3171"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.2853 13.0005H22.3402C22.0895 13.0005 21.8862 13.2037 21.8862 13.4545V14.4273C21.8862 14.678 22.0895 14.8812 22.3402 14.8812H27.2853C27.5361 14.8812 27.7393 14.678 27.7393 14.4273V13.4545C27.7393 13.2037 27.5361 13.0005 27.2853 13.0005Z",
			fill: "#1F3171"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 38.5,
			cy: 30.5,
			r: 5,
			fill: "#1F3171",
			stroke: "#1F3171"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 38,
			y: 28,
			width: 1,
			height: 3.5,
			rx: .5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 38,
			y: 32,
			width: 1,
			height: 1,
			rx: .5,
			fill: "white"
		})
	]
});
export default SvgBatteryStatusIcon;
